<template>
  <div class="team">
    <div class="row">
      <div class="col-lg-12 header-text">
        <div class="pre-header"></div>
        <before-form-header :title="$t('views.loan-originators.loanOriginators')" class="header-table over-header" :description="$t('views.loan-originators.learnMoreAbout')"/>
      </div>
    </div>
    <div class="container">
      <div class="row">
    <originator-details v-for="(originator, index) in originators"
                 v-bind:newline="index%2!==0"
                 v-bind:key="index"
                 v-bind:originator="originator"></originator-details>
      </div></div>
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="home-start-investing">
            <h2>{{ $t('views.loan-originators.startInvestingToday') }}</h2>
            <div class="detail-info">{{ $t('views.loan-originators.earnUpTo') }}</div>
            <get-started/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GetStarted from '../components/GetStarted'
import OriginatorDetails from '@/components/OriginatorDetails'
import BeforeFormHeader from '@/components/BeforeFormHeader';

export default {
  name: 'Loan-originators',
  components: {
    BeforeFormHeader,
    OriginatorDetails,
    GetStarted
  },
  data()
  {
    return {
      originators: [
        {
          name: 'ITF Bulgaria',
          country: 'bg',
          isEUFlag: true,
          description: 'ITF Group operates and constantly develops its 360 degrees proprietary platform, featuring end-to-end technological solutions for risk assessment, customer support, loan issuing, cash flow management, and BI reporting. As a result, the company has achieved a high level of automation - 60+% of all requests have been fully automated within a couple of seconds. This provides lower operational costs and higher efficiency by eliminating human mistakes. Company strategy is conservative and oriented towards stability and annual profits. As a result of the constant portfolio growth, the company is constantly looking to optimize its channels to get capital for its borrowing activities.',
          buyback_guarantee: '60 days, covers Principal and Interest',
          security: 'Assignment of receivables',
          interest_rate_offered: 'Up to 15% per annum',
          skin_in_the_game: '10%-20%',
          image: 'itf.png',
          read_more_link: 'https://getincome.com/loan-originators/itf-bulgaria/',
          presentation_link: '',
          logo_alt: 'ITF Bulgaria'
        },
        {
          name: 'Vivus Mexico',
          country: 'mx',
          description: 'Vivus Mexico is a SOFOM licensing lender that offers short-term loans and installment loans. The company has been active in Mexico for more than six years during which they have serviced 800 000 satisfied customers. \n' +
              '\n' + 'The company´s management team has strong and proven international experience. Since Summer 2020 Vivus Mexico has been part of Digital Finance International. DFI is a global leader in digital lending operating in 23 markets with consumer finance products, offering modern and demanding financial products for millions of underserved and underbanked customers globally.',
          buyback_guarantee: 'Indirect, 60 DPD removed from collateral',
          security: '132% pledged consumer loans',
          interest_rate_offered: 'up to 15% per annum',
          skin_in_the_game: 'Equivalent of 33%',
          image: 'logo-vivus-mexico.png',
          read_more_link: 'https://getincome.com/loan-originators/vivus-mexico/',
          presentation_link: '',
          logo_alt: 'Vivus Mexico'
        },
        {
          name: 'Hoovi',
          country: 'ee',
          isEUFlag: true,
          description: 'HOOVI is an Estonian Loan Originator who combines technology and automation with standardized processes and human expertise to achieve a lending process that is both fast and automated in the background but personalized and human-centric on the front office side. \n' +
              'HOOVI started as Securebadger in 2018. A group of professionals from the finance and real estate sectors as founders.',
          buyback_guarantee: '60 DPD, covers Principal and Interest',
          security: 'Assignment of receivables',
          interest_rate_offered: '12% per annum',
          skin_in_the_game: '20%',
          image: 'hoovi_logo.png',
          read_more_link: 'https://getincome.com/loan-originators/hoovi/',
          presentation_link: '',
          logo_alt: 'HOOVI is an Estonian Loan Originator'
        },
        {
          name: 'Danabijak',
          country: 'id',
          description: 'Danabijak is a fintech lending company with offices in Singapore and Indonesia. The Danabijak lending platform focuses on big data and technology to advance financial inclusion and connects lenders with Indonesian individual borrowers. \n' +
            '\n' +
            'The company was established in 2016 and is licensed by Indonesia´s Financial Supervisory Authority (“Otoritas Jasa Keuangan”) as a Peer-to-Peer Fintech lending platform since June 2018.',
          buyback_guarantee: '60 DPD, covers Principal and Interest',
          security: 'Assignment of receivables',
          interest_rate_offered: '12% per annum',
          skin_in_the_game: '34-67%',
          image: 'danabijak.png',
          read_more_link: 'https://getincome.com/loan-originators/danabijak/',
          presentation_link: ''
        },
        {
          name: 'Danarupiah',
          country: 'id',
          description: 'DanaRupiah is a Fintech (Financial Technology) Company that has officially been permitted and supervised by OJK KEP-18/D.05/2020 since May 19th, 2020. As a legal and credible Fintech company, DanaRupiah provides financial services through an online lending service platform, with a mission to become one of the most trusted financial solutions that contribute to improving society’s standard of living by providing various short-term loan options.',
          buyback_guarantee: '60 DPD, covers Principal and Interest',
          security: 'Assignment of receivables',
          interest_rate_offered: 'up to 15% per annum',
          skin_in_the_game: '22 %',
          image: 'danarupiah.png',
          read_more_link: 'https://getincome.com/loan-originators/danarupiah/',
          presentation_link: '',
          logo_alt: 'Danarupiah'
        },
        {
          name: 'ClickCash',
          country: 'br',
          description: 'ClickCash (Credito 24 LTDA) s a Brazilian non-bank financial company (Fintech) that offers consumer loans to its customers via a proprietary “mobile only” process that enables it to tap into alternative credit data and to detect fraud efficiently. \n' +
              '\n' +
              'The company was established in  2019 and has quickly reached profitable origination on a loan level and is looking to scale up its business fast.',
          buyback_guarantee: 'Indirect,  60 DPD removed from collateral',
          security: '139% pledged consumer loans ',
          interest_rate_offered: '12% per annum',
          skin_in_the_game: 'Equivalent of 28%',
          image: 'clickcash.png',
          read_more_link: 'https://getincome.com/loan-originators/clickcash/',
          presentation_link: ''
        },
        {
          name: 'FIN Yritysrahoitus',
          country: 'fi',
          isEUFlag: true,
          description: 'FIN Yritysrahoitus is a Finnish loan originator that specializes in financing small and medium sized companies in Finland. The <span class="d-inline-block text-nowrap">company´s</span> business idea is to service Finnish entrepreneurs on-line with flexible process and eliminating unnecessary bureaucracy that companies often face when dealing with local banks. \n' +
            '\n' +
            'The company was established in February 2014 and has since grown to be an established and known loan originator among Finnish SME´s looking for fast credit with simple process. The company has established processes for collection and significant track record in originating loans to SME´s.',
          buyback_guarantee: '60DPD, covers Principal and Interest',
          security: 'Assignment of receivables',
          interest_rate_offered: '7% per annum',
          skin_in_the_game: '22%',
          image: 'fin-yritysrahoitus.png',
          read_more_link: 'https://getincome.com/loan-originators/fin-yritysrahoitus/',
          presentation_link: '',
          logo_alt: 'FIN Yritysrahoitus'
        },
        {
          name: 'Juancho',
          country: 'co',
          description: 'Juancho te Presta is one of Colombia\'s fastest-growing fintech lending companies.' + '\n' +
              'Juancho te Presta offers personal loans and buy now, pay later solutions to its customers. It aims to increase financial inclusion and access to credit in Colombia through its 100% digital loan application and lending solutions.' + '\n' +
              'Over EUR 7.3 million worth of loans has been originated by Juancho te Presta since 2019.',
          buyback_guarantee: '60 days, covers Principal and Interest',
          security: 'Assignment of receivables',
          interest_rate_offered: '15%',
          skin_in_the_game: '15 - 30%',
          image: 'logo-juancho.png',
          read_more_link: 'https://getincome.com/loan-originators/juancho/',
          presentation_link: '',
          custom_class: 'juancho',
          logo_alt: 'Juancho'
        },
        {
          name: 'Coming Soon',
          country: 'eu',
          description: 'We are constantly looking for  loan originators to join Income. Once we have completed due dilligence and signed the agreements the loan originators will be listed on this page. ',
          buyback_guarantee: '60 days, covers Principal and Interest',
          security: 'Assignment of receivables',
          interest_rate_offered: '8-15% per annum',
          skin_in_the_game: 'TBA',
          image: 'income.svg',
          read_more_link: '',
          presentation_link: '',
          logo_alt: 'Income Marketplace'
        }
      ]
    }
  }
}
</script>

<style  lang="scss">
.juancho {
  a:first-child {
    float: left;
    margin-right: 25px;
    .logo{
      height: 120px !important;
    }
  }
  .head{
    margin-top: 45px;
  }
  .info{
    display: inline-block;
  }
  .juancho-cs {
    line-height: 30px;
    font-weight: bold;
    font-size: 26px;
  }
}
</style>

<style scoped lang="scss">

.header-text {
  text-align: center;
  //padding-left: 8%;
  margin: 82px auto 70px;

  h1 {
    font-style: normal;
    font-weight: bold;
    font-size: 64px;
    line-height: 64px;
    text-align: center;
    color: #000000;
    flex: none;
    max-width: 725px;
    margin: auto auto 15px;

    .blue {
      color: #30A7FE;
    }
  }

  h3 {
    font-style: normal;
    font-weight: normal;
    font-size: 21px;
    line-height: 28px;
    text-align: center;
    color: #6E777A !important;
    flex: none;
    order: 2;
    align-self: center;
    margin: auto auto 16px;
    max-width: 826px;
  }

  .pre-header {
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    color: #9DA0A6;
    flex: none;
    order: 0;
    align-self: center;
    margin: 0 16px 15px;
  }
}

.simple-it-gets {
  background-color: #000000;
  color: #FFFFFF;
  text-align: center;

  h2 {
    margin-top: 50px;
    margin-bottom: 16px;
    font-style: normal;
    font-weight: bold;
    font-size: 36px;
    line-height: 40px;
    text-align: center;
    color: #FFFFFF;
  }

  img {
    max-width: 642px;
    width: 100%;
    margin-bottom: 35px;
  }
}

.home-start-investing {
  text-align: center;
  margin-top: 80px;
  margin-bottom: 100px;
  font-style: normal;

  h2 {
    font-size: 36px;
    line-height: 40px;
    font-weight: bold;
    color: #000000;
  }

  .detail-info {
    font-weight: normal;
    font-size: 21px;
    line-height: 28px;
    color: #9DA0A6;
  }
}

.ensuring-description {
  font-size: 21px;
  line-height: 28px;
  text-align: center;
  color: #9DA0A6;
  max-width: 800px;
  margin: auto auto 20px;
}

.equal-opportunity {
  border: 1px solid #D6D6D6;
  box-sizing: border-box;
  border-radius: 10px;
  background-image: url("../assets/team/team-member.svg");
  background-position: left 0;
  background-repeat: no-repeat;
  height: auto;
  margin-bottom: 40px;
  margin-top: 40px;

  .circle {
    background: #30A7FE;
    border-radius: 108px;
    border: 10px solid #30A7FE;
    font-weight: bold;
    font-size: 18px;
    line-height: 30px;
    text-align: center;
    color: #FFFFFF;
    max-width: 270px;
    font-style: normal;
    padding: 38px;
    margin: 120px auto auto 56%;
  }

  .text {
    margin-top: 100px;
    margin-bottom: 100px;
    margin-left: 50px;

    .head {
      font-style: normal;
      font-weight: bold;
      font-size: 36px;
      line-height: 40px;
      color: #000000;
      flex: none;
      order: 0;
      align-self: flex-start;
      margin: 0 16px;
    }

    .info {
      font-style: normal;
      font-weight: normal;
      font-size: 21px;
      line-height: 28px;
      color: #6E777A;
      flex: none;
      order: 1;
      align-self: flex-start;
      margin: 0 16px;
    }
  }
}

.info-img {
  text-align: center;
  width: 100%;

  img {
    max-width: 80px;
  }
}

.compare-ways {
  text-align: center;
  margin-top: 25px;

  h2 {
    font-style: normal;
    font-weight: bold;
    font-size: 36px;
    line-height: 40px;
    text-align: center;
    color: #000000;
    margin-bottom: 10px;
  }

  table {
    margin-top: 15px;
  }
}
</style>
